export default __webpack_public_path__ + "static/media/announcement_1@2x.27968c1d.png";